import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {Review} from '../../network/review.ts';
import {ReviewQuery} from '../../gql/pwa/graphql.ts';

const KLANTENVERTELLEN = 'klantenvertellen';

interface State extends ReviewQuery {}

export const fetchReview = createAsyncThunk('review/fetch', async (data: {page: number}) => {
    const result = await Review.getReview(data.page, KLANTENVERTELLEN);
    return result.data;
});

export const reviewSlice = createSlice({
    name: 'review',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchReview.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(fetchReview.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.review = action.payload.review;
            state.__typename = action.payload.__typename;
        });
        builder.addCase(fetchReview.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
